export const visit = (vm, at) => {
vm(require("foundations-components/lang/ar-eg.lyaml"));
at({ "ar-eg": { "placeholder": "\u0639\u0646\u0635\u0631 \u0646\u0627\u0626\u0628" } });
};